import React from 'react';
import { Route } from 'react-router-dom';

/**
 * MyRoute Component
 * Flexible route component that supports both single and multiple components
 * Useful for route layouts with nested components
 */
export const MyRoute = ({ component: Component, ...rest }) => {
  const renderComponent = (props) => {
    // Support multiple components (array pattern)
    if (Array.isArray(Component)) {
      return Component.map((comp, key) =>
        React.createElement(comp, {
          ...props,
          key: `${key}-my-route-${rest.path}`,
        })
      );
    }

    // Single component
    return <Component {...props} />;
  };

  return <Route {...rest} render={renderComponent} />;
};